<div class="container-fluid p-3">
  <div class="page-header mb-4">
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <!-- <h4 class="mb-1">Draft SOC</h4> -->
         {{ stepDetails?.name }}
        <h5 class="text-primary">[{{ payload?.proposal_name }}]</h5>
        <div class="status-badge">
          <span class="badge" [ngClass]="{
              'bg-secondary': stepDetails?.step_status == 0,
              'bg-success': stepDetails?.step_status == 'approved',
              'bg-warning': stepDetails?.step_status == 'recommended',
              'bg-info': stepDetails?.step_status == 'initiated'
            }">
            {{
            stepDetails?.step_status == 0
            ? "INITIATION PENDING"
            : (stepDetails?.step_status | uppercase)
            }}
          </span>
        </div>
      </div>

      <div class="action-buttons">
        <button class="btn btn-blue me-2" (click)="generatePDF()">
          <i class="pi pi-file-pdf me-1"></i> PDF
        </button>

        <ng-container *ngIf="stepDetails?.step_status == 'approved'">
          <button class="btn btn-outline-primary me-2" (click)="goToNextStep()">
            Next <i class="pi pi-angle-right ms-1"></i>
          </button>
        </ng-container>

        <ng-container *ngIf="stepDetails?.can_edit || (stepDetails?.step_status != 'approved' && userID == 6)">
          <button (click)="routeConfig.emit({isRouteConfig: true})" 
                  [disabled]="(schemeType === 'tdf' && proposalForm?.invalid) || (schemeType !== 'tdf' && challengeForm?.invalid)"
                  class="inline-flex items-center px-4 py-2.5 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 disabled:bg-slate-300 disabled:cursor-not-allowed transition-all duration-200 font-medium text-sm shadow-sm hover:shadow-md">
            <i class="pi pi-save mr-2"></i> Save/Forward/Route Config
          </button>
        </ng-container>

        <ng-container *ngIf="stepDetails?.is_initiator">
          <button class="btn btn-success" (click)="IRA.emit('Initiate')">
            <i class="pi pi-play me-1"></i> Initiate
          </button>
        </ng-container>

        <ng-container *ngIf="stepDetails?.is_approver">
          <button class="btn btn-success" (click)="IRA.emit('Approve')">
            <i class="pi pi-check-circle me-1"></i> Approve
          </button>
        </ng-container>

        <ng-container *ngIf="stepDetails?.is_recommender">
          <button class="btn btn-info" (click)="IRA.emit('Recommend')">
            <i class="pi pi-thumbs-up me-1"></i> Recommend
          </button>
        </ng-container>
      </div>
    </div>
  </div>

  <hr class="my-3" />
  <div class="proposal-form-container">
    <div class="form-container">
      <!-- === File Upload Section === -->
      <div class="form-section">
        <div class="section-header" (click)="toggleSection('uploads')">
          <h3 class="section-title">
            Document Uploads
            <i class="pi" [ngClass]="expandedSections['uploads'] ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
          </h3>
        </div>

        <!-- File Uploads Section -->
        <div class="section-content" *ngIf="expandedSections['uploads']">
          <div class="form-section">
            <!-- <h3 class="section-title">Document Uploads</h3> -->
            <!-- Document Upload Table -->
            <!-- <app-upload-document (uploadData)="onDocumentUpload($event)" [isEditable]="stepDetails?.can_edit" [dmsFiles]="allDmsFiles"
              (documentEdited)="onDocumentEdited($event)" (documentDeleted)="onDocumentDeleted($event)">
            </app-upload-document> -->
            <app-upload-document [isEditable]="stepDetails?.can_edit" [id]="id"></app-upload-document>
            <!-- 🔹 Upload Progress Indicator -->
            <div class="mt-3" *ngIf="uploadProgress > 0">
              <div class="progress" style="height: 10px;">
                <div class="progress-bar progress-bar-striped progress-bar-animated bg-success" role="progressbar"
                  [style.width.%]="uploadProgress">
                  {{ uploadProgress }}%
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

   <div *ngIf="schemeType === 'makeI' || schemeType === 'makeII' || schemeType === 'makeIII'" class="form-container">
   

      <div class="editor-field mt-4">
        <p class="bg-blue-500 p-2 text-white font-medium">SOC Content</p>
        <editor
  *ngIf="editorReady"
  [init]="socContentData"
  [(ngModel)]="soc_content">
</editor>
      </div>

    </div>

  <!-- Remarks Section -->
  <div class="row mt-4">
    <div class="col-4 bg-primary text-white d-flex align-items-center">
      <b class="fw-semibold mb-0 text-white">Remarks  </b>
    </div>
    <div class="col-8">
      <textarea id="remarks" class="form-control" [(ngModel)]="remark" rows="4" placeholder="Enter any remarks..." [disabled]="isEditorDisabled"></textarea>
    </div>
  </div>
</div>


